import { Flex, Icon, Text } from '@skin-seoul/design-system';
import type { ComponentProps } from 'react';
import React from 'react';
type MobileNavbarItemProps = ComponentProps<typeof Flex> & {
  icon: React.ReactNode;
  label: string;
  onClick?: () => void;
};
const MobileNavbarItem = ({
  icon,
  label,
  onClick,
  ...rest
}: MobileNavbarItemProps) => {
  return <Flex as="button" height="63px" flexDirection="column" width="20%" gap={1} alignItems="center" justifyContent="center" role="button" aria-label={label} onClick={onClick} backgroundColor="transparent" border="none" {...rest} data-sentry-element="Flex" data-sentry-component="MobileNavbarItem" data-sentry-source-file="MobileNavbarItem.tsx">
      <Icon color="neutral.500" aria-hidden="true" height="24px" width="24px" data-sentry-element="Icon" data-sentry-source-file="MobileNavbarItem.tsx">
        {icon}
      </Icon>
      <Text textStyle="label.small" color="neutral.500" data-sentry-element="Text" data-sentry-source-file="MobileNavbarItem.tsx">
        {label}
      </Text>
    </Flex>;
};
export default MobileNavbarItem;